'use client';

import { forwardRef } from 'react';
import type { BadgeProps as MantineBadgeProps } from '@mantine/core';
import { Badge as MantineBadge } from '@mantine/core';

import type { LockedProps } from '../types';

export type BadgeProps = Omit<MantineBadgeProps, LockedProps>;

/**
 * ### Badge
 *
 * @description
 * Mantine's Badge minus per-call-site style overrides (see {@link LockedProps}). `color`
 * takes a theme color key — prefer those, since the `light` variant maps them to the tuned
 * `--mantine-color-{color}-light`/`-light-color` pair. The default look (`variant="light"`,
 * `color="gray"`) comes from the theme's Badge defaultProps.
 *
 * @example
 * ```tsx
 * <Badge>Gray Badge</Badge>
 * <Badge color="green">Green Badge</Badge>
 * ```
 *
 * @param props - {@link BadgeProps}
 * @returns React component
 */
const Badge = forwardRef<HTMLDivElement, BadgeProps>((props, ref) => (
  <MantineBadge {...props} ref={ref} />
));

Badge.displayName = 'Badge';

export default Badge;
